<template>
  <div tft-university-showdown-schedule>
    <PSection class="contents-holder">
      <div class="lockup">
        <p class="brand">TEAMFIGHT TACTICS</p>
        <h3 class="name">UNIVERSITY<br>SHOWDOWN</h3>
        <i class="rule" />
        <p class="sub">TFT 대학 리그</p>
      </div>
      <div class="schedule">
        <div v-for="box in boxes" :key="box.key" :class="['box', box.key]">
          <h4 class="anchor"><span>{{ box.title }}</span></h4>
          <ul>
            <li v-for="(item, idx) in box.list" :key="`${box.key}-${idx}`">
              <i class="hex" />
              <em>{{ item.week }}</em>
              <span>{{ item.date }}</span>
            </li>
          </ul>
        </div>
      </div>
    </PSection>
  </div>
</template>

<script>
export default {
  name: 'TftUniversityShowdownSchedule',
  props: {
    applyDate: {
      type: Array,
      default: () => [],
    },
    playDate: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    boxes() {
      return [
        { key: 'apply', title: '접수기간', list: this.applyDate },
        { key: 'play', title: '대회기간', list: this.playDate },
      ];
    },
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';

[tft-university-showdown-schedule] { .mt(40); .p(0, 20);
  .accent(@c) {
    .anchor { &:before { .bgc(@c); } > span { .bgc(@c); } }
    .hex { .bgc(@c); }
    li > em { .c(@c); }
  }
  .contents-holder { .ani-base;
    .intro-up(1, { .ani-on; });
  }
  .lockup { .tc; .mb(36);
    .brand { .font-russo; .fs(14, 14); .ls(2); .c(@showdown-gold); }
    .name { .font-russo; .fs(40, 44); .ls(1); .c(@showdown-cream); .mt(8); }
    .rule { .rel; .block; .wh(220, 6); .m(14, auto, 0); .bgc(@showdown-gold);
      &:before, &:after { .cnt; .abs; .t(-5); .wh(64, 11); .bgc(@showdown-gold); }
      &:before { .l(0); clip-path: polygon(0 0, 100% 0, calc(100% - 6px) 100%, 0 100%); }
      &:after { .r(0); clip-path: polygon(0 0, 100% 0, 100% 100%, 6px 100%); }
    }
    .sub { .font-g; .bold; .fs(20, 20); .ls(-1); .c(@showdown-cream); .mt(16); }
  }
  .schedule { .max-w(520); .mh-c;
    .box { .rel; .mb(28); .p(0, 18, 20); .bgc(fade(@showdown-navy-deep, 70%)); box-shadow: inset 0 0 0 1px fade(@showdown-gold, 35%); .tl;
      clip-path: polygon(0 0, 100% 0, 100% calc(100% - 18px), calc(100% - 11px) 100%, 0 100%);
      &:last-child { .mb(0); }
    }
    .anchor { .rel; .h(34); .m(0, -18, 14);
      &:before { .cnt; .abs; .lb(0, 0); .wh(100%, 4); }
      > span { .rel; .ib; .h(34); .p(0, 34, 0, 18); .font-g; .bold; .fs(16, 34); .ls(-0.5); .c(@showdown-navy-deep);
        clip-path: polygon(0 0, 100% 0, calc(100% - 20px) 100%, 0 100%);
      }
    }
    .apply { .accent(@showdown-gold); }
    .play { .accent(@showdown-cream);
      li > em { .w(78); }
    }
    li { .flex; .items-center; .h(36); .font-g;
      .hex { .no-shrink; .wh(12, 10); .mr(10); clip-path: polygon(25% 0, 75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%); }
      > em { .no-shrink; .w(64); .nowrap; .bold; .fs(14, 14); .ls(-0.5); }
      > span { .nowrap; .bold; .fs(14, 14); .ls(-0.5); .c(@showdown-cream); }
    }
  }

  @media (@tl-up) {
    .mt(56); .p(0, 58);
    .contents-holder { .flex; .items-center; .flex-jc(space-between); }
    .lockup { .no-shrink; .tl; .mb(0);
      .brand { .fs(18, 18); }
      .name { .fs(48, 52); }
      .rule { .w(300); .ml(0); }
      .sub { .fs(24, 24); }
    }
    .schedule { .flex; .items-start; .gap(20); .max-w(none); .m(0);
      .box { .mb(0); .p(0, 20, 22); }
      .anchor { .h(40); .m(0, -20, 16);
        > span { .h(40); .p(0, 40, 0, 20); .fs(18, 40); }
      }
      li { .h(40);
        > em { .w(66); .fs(15, 15); }
        > span { .fs(15, 15); }
      }
    }
  }

  @media (@ds-up) {
    .p(0);
    .lockup .name { .fs(68, 72); }
  }
}
</style>
